export default "__VITE_ASSET__a2Nb4hOx__"